export function bookEditingPayload(form, version) {
  const { title, subtitle, author, synopsis, language, keywords, price } = form;
  const names = [
    "interiorColor",
    "publicationYear",
    "edition",
    "finish",
    "formatType",
    "publisher",
    "classificationType",
    "bisacSubject",
    "ageRange",
    "hasSeries",
    "collectionName",
    "collectionVolume",
    "categories",
    "people",
    "weightGr",
    "depthCm",
    "publicationDetailsConfirmed",
  ];
  const details = Object.fromEntries(names.map((name) => [name, form[name]]));

  return { title, subtitle, author, synopsis, language, keywords, price, version, details };
}
